import request from './common/request'
import qs from 'qs'

import { SIMBART_MERCHANT_ACTIVITY_JOIN_COMPETITION_URL } from './urls'

// 列表
async function list (params) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_JOIN_COMPETITION_URL}`,
      method: 'GET',
      params
    }
  )
}

async function detail (id) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_JOIN_COMPETITION_URL}/${id}`,
      method: 'GET'
    }
  )
}

/**
 * 获取报名列表
 * @param {*} params
 * @returns
 */
async function listEntryValue (params) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_JOIN_COMPETITION_URL}/${params.competitionId}/entryvalues`,
    method: 'GET',
    params: params
  })
}

async function listPartner (params) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_JOIN_COMPETITION_URL}/${params.competitionId}/partners`,
    method: 'GET',
    params: params
  })
}

async function getPartner (params) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_JOIN_COMPETITION_URL}/${params.competitionId}/partner`,
    method: 'GET',
    params: params
  })
}

// 列表
async function listGroup (params) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_JOIN_COMPETITION_URL}/${params.competitionId}/groups`,
      method: 'GET'
    }
  )
}

// 列表
async function listCategory (params) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_JOIN_COMPETITION_URL}/${params.competitionId}/categories`,
      method: 'GET'
    }
  )
}

async function listMatch (params) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_JOIN_COMPETITION_URL}/${params.competitionId}/matches`,
      method: 'GET'
    }
  )
}

async function listCommission (params) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_JOIN_COMPETITION_URL}/${params.competitionId}/partner/${params.partnerId}/commissions`,
    method: 'GET'
  })
}

async function saveCommission (data) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_JOIN_COMPETITION_URL}/${data.competitionId}/partner/${data.partnerId}/commissions`,
    method: 'POST',
    data: qs.stringify(data)
  })
}

async function changePartnerStatus (data) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_JOIN_COMPETITION_URL}/${data.competitionId}/partner/${data.partnerId}/status/${data.status}`,
    method: 'PUT'
  })
}

async function allStages (params) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_JOIN_COMPETITION_URL}/${params.competitionId}/stages/all`,
    method: 'GET',
    params
  })
}

async function allMatches (params) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_JOIN_COMPETITION_URL}/${params.competitionId}/matches/all`,
    method: 'GET',
    params
  })
}

async function allSessions (params) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_JOIN_COMPETITION_URL}/${params.competitionId}/sessions/all`,
    method: 'GET',
    params
  })
}

export default {
  list,
  detail,
  listEntryValue,
  listPartner,
  getPartner,
  listGroup,
  listCategory,
  listMatch,
  listCommission,
  saveCommission,
  changePartnerStatus,
  allStages,
  allMatches,
  allSessions
}



// WEBPACK FOOTER //
// ./src/api/merchant-simbart-activity-join-competition.js